import { db } from "../../../firebase";
import { db_format } from "./general.js";

export async function get_word(word, lang) {
	return await db
		.collection(lang + "_dictionary")
		.doc(word)
		.get()
		.then((doc) => doc.data());
}

export function add_new_word(word, lang) {
	const ref = db.collection(lang + "_dictionary").doc(word);

	return ref.get().then(async (doc) => {
		if (!doc.exists) {
			await ref.set({ word, trans: "UNFETCHED" });
		}
		return;
	});
}

export async function update_dictionary(parsed_lines, lang) {
	console.log("Update started.");
	let promises = [];
	for (let i = 0; i < parsed_lines.length; i++) {
		const words = parsed_lines[i]["split_" + lang];
		if (words)
			for (let j = 0; j < words.length; j++) {
				let word = db_format(words[j]);
				promises.push(add_new_word(word, lang));
			}
	}
	await Promise.all(promises);
	console.log("Update done.");
}
